import axios from "axios";

const inovacenter_api = axios.create({
    baseURL: "https://apicenter.inovacode.app.br/"
})

export default inovacenter_api